<template lang="pug">
.bq-notfound
    router-link.bq-logo(to="/" translate="no" title="Skapi")
        img.bq-logo-icon(src="/skapi-logo-cut-small.png" alt="Skapi logo")
    .bq-code 404
    //- The page's one heading. Styled as the small muted line it always was.
    h1.bq-msg Page not found
    .bq-back
        router-link.bq-cta-link(to="/")
            span.bq-arrow.bq-arrow--lead(translate="no") &larr;
            | Back to home
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { removeFullScreenLoader } from '@/components/jsComponents';

onMounted(() => {
    removeFullScreenLoader();
});
</script>

<style scoped lang="less">
@import "@/assets/less/bq-tokens.less";

.bq-notfound {
    max-width: 440px;
    padding: 8rem 1.5rem;
    margin: 0 auto;
    font-family: @mono;
    color: @ink;
    text-align: center;
}

.bq-logo {
    font-size: 1.2rem;
    color: @ink;
    text-decoration: none;
    letter-spacing: 0.04em;
}

.bq-code {
    font-size: 4rem;
    font-weight: 700;
    margin: 2rem 0 0.5rem;
    letter-spacing: -0.02em;
}

/* An h1 that keeps the look of the <p> it replaced: paragraph margins and
   line height (base.less), and the surrounding weight instead of the 500 that
   base.less gives headings. */
.bq-msg {
    margin: 1em 0 2rem;
    font-size: 0.92rem;
    font-weight: inherit;
    line-height: 1.5;
    color: @muted;
}
// The wrapper stays muted; the link inside it carries .bq-cta-link, which
// supplies the ink colour, the underline and the pink hover.
.bq-back {
    font-size: 0.82rem;
    color: @muted;
    text-align: center;
}
</style>